import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FAST_TRACK_INFO_DIALOG_TEXTS } from '../fast-track.constants';

@Component({
  selector: 'app-fast-track-information-dialog',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './fast-track-information-dialog.component.html',
  styleUrl: './fast-track-information-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FastTrackInformationDialogComponent {
  readonly texts = FAST_TRACK_INFO_DIALOG_TEXTS;
}
